<template>
  <el-card>
    <PdvPrintDialog
      :visible.sync="dialog"
      :proof="pdf.proof"
      :prepost="pdf.prepost"
      :external="pdf.external"
      :motoboy="pdf.motoboy"
    />
    <PdvCallOpenCashier ref="openCashier" />
    <div slot="header" class="pdv-header">
      <div class="pdv-header__title">
        <el-page-header
          @back="back"
          tabindex="-1"
          title
          :content="$t('pdv-atendimento')"
        ></el-page-header>
        <span v-if="customer.name" class="pdv-store" :title="customer.name">
          <i class="el-icon-office-building"></i>
          {{ customer.name }}
        </span>
      </div>
      <div class="pdv-header__actions">
        <PdvDeposit
          title="Adicionar dinheiro ao caixa"
          type="info"
          state="1"
          label="Depositar"
        />
        <PdvDeposit
          title="Retirar dinheiro ao caixa"
          type="info"
          state="2"
          label="Retirar"
        />
        <PdvReversal />
        <el-button
          @click="$router.replace({ name: 'pdv.cashier.close' })"
          type="success"
          >Fechar Caixa</el-button
        >
      </div>
    </div>
    <PdvCallSender ref="sender" @focus="focus" />
    <el-tabs type="card" v-model="activeTab" @tab-click="change" tabindex="-1">
      <el-tab-pane name="delivery" tabindex="-1" label="delivery">
        <span slot="label" tabindex="-1">
          <i class="el-icon-s-cooperation"></i>&nbsp;Postagem
        </span>
        <PdvCallDelivery
          ref="delivery"
          :customer="customer"
          :licence="licence"
          :name="$refs.sender ? $refs.sender.ruleForm.name : ''"
          :phone="$refs.sender ? $refs.sender.ruleForm.phone : ''"
          :mail="$refs.sender ? $refs.sender.ruleForm.mail : ''"
        />
      </el-tab-pane>
      <el-tab-pane name="external" label="external">
        <span slot="label" tabindex="-1">
          <i class="el-icon-tickets"></i>&nbsp;PLP Terceiro
        </span>
        <PdvCallExternal ref="external" :customer="customer" />
      </el-tab-pane>
      <el-tab-pane name="reverse" label="reverse">
        <span slot="label">
          <i class="el-icon-takeaway-box"></i>&nbsp;Reversa
        </span>
        <PdvCallReverse ref="reverse" :customer="customer" />
      </el-tab-pane>
      <el-tab-pane name="closed" label="closed">
        <span slot="label">
          <i class="el-icon-check"></i>&nbsp;Encerrar
          <sup
            class="el-badge__content el-badge__content--success is-fixede"
            style="top: -2px; right: -2px; position: absolute"
            >{{ total }}</sup
          >
        </span>
        <PdvCallClosed
          ref="closed"
          :customer="customer"
          @pdvadd="add"
          @pdvremove="remove"
          @close="close"
          :licence="licence"
          @clear="clear"
          @open="dialog = true"
        />
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import { UserService } from "@/services/users/user.services";
import { PdvService } from "@/services/pdv/pdv.services";
import { PdvCashierService } from "@/services/pdv/pdv.cashier.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import PdvCallSender from "./call/PdvCallSender";
import PdvCallDelivery from "./call/PdvCallDelivery";
import PdvCallExternal from "./call/PdvCallExternal.vue";
import PdvCallReverse from "./call/PdvCallReverse.vue";
import PdvCallClosed from "./call/PdvCallClosed.vue";
import PdvCallOpenCashier from "./call/PdvCallOpenCashier.vue";
import PdvDeposit from "./call/cashier/PdvDeposit.vue";
import PdvReversal from "./call/PdvCallReversal.vue";
import PdvPrintDialog from "./call/PdvPrintDialog.vue";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";

export default {
  name: "PdvMain",
  components: {
    PdvDeposit,
    VuePdfApp,
    PdvCallSender,
    PdvCallDelivery,
    PdvCallExternal,
    PdvCallReverse,
    PdvCallClosed,
    CustomerList,
    PdvCallOpenCashier,
    PdvReversal,
    PdvPrintDialog,
  },
  data() {
    return {
      activeTab: "delivery",
      userType: "1",
      dialog: false,
      customer: {
        id: "",
        name: "",
      },
      licence: "",
      total: 0,
      pdf: {
        proof: null,
        prepost: null,
        external: null,
        motoboy: null,
        labels: null,
      },
      ClientId: null,
      clientWhatsapp: "",
    };
  },
  computed: {
    draft() {
      return {
        sender: this.$refs.sender.ruleForm,
        delivery: this.$refs.delivery.ruleForm,
        external: this.$refs.external.ruleForm,
        reverse: this.$refs.reverse.ruleForm,
        closed: this.$refs.closed.ruleForm,
      };
    },
  },
  created() {
    window.addEventListener("keydown", this.keydown);
  },
  destroyed() {
    window.removeEventListener("keydown", this.keydown);
  },
  methods: {
    startup() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const callData = this.$store.getters["pdv/attendence"];
      if (callData && callData.sender && callData.sender.name) {
        vm.$refs.sender.startup(callData.sender);
        vm.$refs.delivery.startup(callData.delivery);
        vm.$refs.external.startup(callData.external);
        vm.$refs.reverse.startup(callData.reverse);
        vm.$refs.closed.startup(callData.closed);
      }
      PdvCashierService.status()
        .then((response) => {
          if (response.status === "2") {
            vm.$refs.openCashier.open(response.balance);
          } else if (
            response.status === "3" ||
            response.status === "4" ||
            response.status === "5"
          ) {
            this.$router.replace({ name: "pdv.cashier.close" });
            this.$message({
              type: "warning",
              duration: 5000,
              message:
                response.status === "3"
                  ? "Caixa em conferência"
                  : response.status === "4"
                  ? "Caixa em autorização"
                  : "Caixa autorizado",
            });
          }
          this.$refs.delivery.clear();
          this.$refs.sender.focus();
        })
        .catch((error) => {
          this.$router.replace({ name: "pdv.cashier.close" });
          this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => loading.close());
    },
    clear() {
      const vm = this;
      const data = vm.draft;
      if (data.closed.external && data.closed.external.length > 0) {
        PdvService.external(data.closed.external)
          .then((response) => {})
          .catch((e) => {});
      }
      if (data.closed.prepost && data.closed.prepost.length > 0) {
        for (const tagData of data.closed.prepost) {
          PdvService.delete(tagData.tag)
            .then((response) => {})
            .catch((e) => {});
        }
      }
      this.$refs.sender.clear();
      this.$refs.delivery.clear();
      this.$refs.external.clear();
      this.$refs.reverse.clear();
      this.$refs.closed.clear();
      //      this.$refs.motoboy.clear();
      this.total = 0;
      this.activeTab = "delivery";
      this.$refs.sender.focus();
      this.$store.commit("pdv/save", {
        sender: {},
        delivery: {},
        external: {},
        reverse: {},
        motoboy: {},
        closed: {},
      });
    },
    open() {
      PdvService.open()
        .then((response) => {
          vm.$store.commit("pdv/id", response);
        })
        .catch((error) =>
          this.$message({ type: "error", duration: 5000, message: error })
        );
    },
    base64ToArrayBuffer(base64) {
      var binaryString = atob(base64);
      var bytes = new Uint8Array(binaryString.length);
      for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    },
    close() {
      const vm = this;
      const data = vm.draft;

      console.log("data", data);
      const money = data.closed.payment.paymentType
        .reduce((a, b) => {
          return a + (+b.money - +b.changed);
        }, 0)
        .toFixed(2);

      const pay =
        data.closed.payment.type === "0"
          ? +(
              +data.closed.payment.total -
              +data.closed.payment.total * (+data.closed.payment.discount / 100)
            ).toFixed(2)
          : +data.closed.payment.total - +data.closed.payment.discount;

      const options =
        +money < +pay
          ? {
              message: `Você está fechando o atendimento recebendo menos dinheiro que o valor a pagar, confirma?`,
              type: "error",
              confirmButtonClass: "danger",
            }
          : {
              message: `Confirma o encerramento do atendimento?`,
              type: "warning",
              confirmButtonClass: "primary",
            };

      this.$confirm(options.message, "Atendimento", {
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        type: options.type,
        confirmButtonClass: options.confirmButtonClass,
      })
        .then(() => {
          const loading = vm.$loading(vm.$options.loading);
          console.log('Objeto enviado para o save ', vm.clientWhatsapp)
          
          PdvService.save({
            name: data.sender.name,
            phone: data.sender.phone,
            mail: data.sender.mail,
            whatsapp: data.sender.whatsapp,
            clientWhatsapp: vm.clientWhatsapp,
            payment: data.closed.payment,
            external: data.closed.external,
            prepost: data.closed.prepost,
            reverse: data.closed.reverse,
            motoboy: data.closed.motoboy,
            printerOptions: data.closed.printerOptions,
          })
            .then((response) => {
              vm.pdf.proof = response.proof;
              vm.pdf.prepost = (response.prepost && response.prepost.data) ? response.prepost.data : response.prepost;
              vm.pdf.external = response.external;
              vm.pdf.motoboy = response.motoboy;
              vm.pdf.labels = response.labels;

              vm.dialog = true;

              /*            var downloadLink = document.createElement("a");
            downloadLink.href = response.proof;
            downloadLink.download = `atendimento.${response.data}.pdf`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            if (response.prepost) {
              var downloadPrepost = document.createElement("a");
              downloadPrepost.href = response.prepost;
              downloadPrepost.download = `postagem.${response.data}.pdf`;
              document.body.appendChild(downloadPrepost);
              downloadPrepost.click();
            }
            if (response.external) {
              var downloadExternal = document.createElement("a");
              downloadExternal.href = response.external;
              downloadExternal.download = `terceiros.${response.data}.pdf`;
              document.body.appendChild(downloadExternal);
              downloadExternal.click();
            }
            if (response.motoboy) {
              var downloadExternal = document.createElement("a");
              downloadExternal.href = response.motoboy;
              downloadExternal.download = `motoboy.${response.data}.pdf`;
              document.body.appendChild(downloadExternal);
              downloadExternal.click();
            }
            if (response.labels) {
              for (const label of response.labels) {
                const pdf = label[0];
                var downloadExternal = document.createElement("a");
                downloadExternal.href = `data:application/pdf;base64,${pdf.content_base64}`;
                downloadExternal.download = `motoboy.${pdf.order_id}.pdf`;
                document.body.appendChild(downloadExternal);
                downloadExternal.click();
              }
            }*/
              vm.$refs.closed.setData(
                response.data,
                response.proof,
                response.prepost,
                response.external,
                response.motoboy
              );
              vm.clear();

              this.$message({
                type: "success",
                duration: 5000,
                message: "Atendimento gerado com sucesso!",
              });
            })
            .catch((error) =>
              this.$message({
                type: "error",
                duration: 5000,
                message: error,
                offset: 45,
              })
            )
            .finally(() => loading.close());
        })
        .catch(() => false);
    },
    add() {
      this.total++;
    },
    remove() {
      this.total--;
    },
    change(ev) {
      const vm = this;
      this.$refs[ev.name].focus();
    },
    focus() {
      const vm = this;
      vm.$refs[vm.activeTab].focus();
    },
    next(el) {
      if (el.target.dataset.next && this.$refs[el.target.dataset.next])
        this.$refs[el.target.dataset.next].$el
          .getElementsByTagName("input")[0]
          .focus();
    },
    keydown(ev) {
      const vm = this;
      vm.$store.commit("pdv/save", vm.draft);
      if (ev.ctrlKey && ev.altKey) {
        if (ev.key === "p") vm.$refs.delivery.calculate();
        else if (ev.key === "f") vm.close();
        else if (ev.key == "F1") {
          this.$refs["delivery"].focus();
          vm.activeTab = "delivery";
        } else if (ev.key == "F2") {
          this.$refs["external"].focus();
          vm.activeTab = "external";
        } else if (ev.key == "F3") {
          this.$refs["reverse"].focus();
          vm.activeTab = "reverse";
        } else if (ev.key == "F4") {
          this.$refs["closed"].focus();
          vm.activeTab = "closed";
        }
      } else if (ev.altKey && !isNaN(+ev.key) && +ev.key >= 0 && +ev.key < 10) {
        vm.$refs[vm.activeTab].hotkey(+ev.key);
      }
    },
    back() {
      this.$router.replace({
        name: "pdv",
      });
    },
  },
  mounted() {
    const vm = this;
    vm.$bus.$on("pdv.created", (data) => {
      vm.$store.commit("pdv/save", vm.draft);
    });
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
        vm.customer = response.customerPdv;

        vm.ClientId = response.id || response.user.id || null;

        // Atendente PDV de loja: usuário tipo 2 (cliente) com pdv = true
        const isAttendant = vm.userType === "2" && response.pdv === true;
        if (vm.userType !== "1" && vm.userType !== "3" && !isAttendant) {
          this.$message({
            type: "error",
            duration: 5000,
            message: "Usuário sem acesso a essa tela",
            offset: 45,
          });
          this.$router.replace({ name: "home" });
        } else if (vm.userType === "3") {
          vm.licence = response.customers.id;
        } else if (vm.userType == "1") {
          vm.licence = response.customerPdv;
        } else {
          // a própria loja (objeto, como no tipo 1): remetentes/destinatários e PIX
          vm.licence = response.customers;
        }

        if (vm.ClientId) {
          UserService.get(vm.ClientId)
            .then((res) => {
              const userObj = res.user || res;
              const whatsapp = userObj.customerPdv.phoneCellphone || "";
              vm.clientWhatsapp = whatsapp;

              console.log(`Data: ${vm.clientWhatsapp} | WhatsApp ${whatsapp}`);
            })
            .catch((err) => {
              console.error("Erro ao carregar user by id:", err);
            });
        }

        console.log("response", vm.licence);
        console.log("ClientId", vm.ClientId);
        console.log("WhatsApp", vm.clientWhatsapp);

        vm.startup();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          duration: 5000,
          message: error,
          offset: 45,
        });
      });
  },
};
</script>

<style scoped>
.badge-close {
  top: 6px !important;
  right: 6px !important;
}

.el-alert__title {
  font-size: 13px !important;
}

/* Cabeçalho: título/PDV à esquerda, ações à direita — quebra em telas menores */
.pdv-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.pdv-header__title {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1 1 auto;
}

/* Nome do PDV como "chip" discreto em vez de input desabilitado */
.pdv-store {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 240px;
  padding: 4px 12px;
  border-radius: 16px;
  background: #f0f2f5;
  color: #22418d;
  font-weight: 600;
  font-size: 13px;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pdv-header__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

/* Respiro vertical entre o cabeçalho, o bloco do cliente e as abas */
.el-tabs {
  margin-top: 4px;
}

@media (max-width: 767px) {
  .pdv-header__actions {
    width: 100%;
  }

  .pdv-store {
    max-width: 100%;
  }
}
</style>
